import { datePrefills } from "constants/time";
import {
  endOfDay,
  endOfMonth,
  isSameDay,
  startOfDay,
  startOfMonth,
  subDays,
  subMonths,
} from "date-fns";
import { formatDateString } from "lib/timeFormats";

// Renders the output of the date range picker in a nice human-readable format
export function getDateRangeLabel(dateStart: Date, dateEnd: Date): string {
  const now = new Date();
  const ranges: { label: string; start: Date; end: Date }[] = [
    {
      label: datePrefills.last24Hours,
      start: subDays(now, 1),
      end: now,
    },
    {
      label: datePrefills.today,
      start: startOfDay(now),
      end: endOfDay(now),
    },
    {
      label: datePrefills.yesterday,
      start: startOfDay(subDays(now, 1)),
      end: endOfDay(subDays(now, 1)),
    },
    {
      label: datePrefills.last7Days,
      start: startOfDay(subDays(now, 6)),
      end: endOfDay(now),
    },
    {
      label: datePrefills.last30Days,
      start: startOfDay(subDays(now, 29)),
      end: endOfDay(now),
    },
    {
      label: datePrefills.last90Days,
      start: startOfDay(subDays(now, 89)),
      end: endOfDay(now),
    },
    {
      label: datePrefills.currentMonth,
      start: startOfMonth(now),
      end: endOfDay(now),
    },
    {
      label: datePrefills.lastMonth,
      start: startOfMonth(subMonths(now, 1)),
      end: endOfMonth(subMonths(now, 1)),
    },
    {
      label: datePrefills.last3Months,
      start: startOfMonth(subMonths(now, 3)),
      end: endOfMonth(subMonths(now, 1)),
    },
    {
      label: datePrefills.last12Months,
      start: startOfMonth(subMonths(now, 12)),
      end: endOfMonth(subMonths(now, 1)),
    },
  ];

  const matchingRange = ranges.find(
    range => isSameDay(dateStart, range.start) && isSameDay(dateEnd, range.end),
  );
  if (matchingRange) {
    return matchingRange.label;
  }

  // Default fallback: custom range display
  return `${formatDateString(dateStart)} - ${formatDateString(dateEnd)}`;
}
